export default __webpack_public_path__ + "static/media/HeroBanner_WithContent.7bf2b6e0.png";